export default "__VITE_ASSET__DhU9FTQk__"